import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../pages/landing/images/logo.png";
import "./site.css";

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  return (
    <header className="site-header" id="top">
      <div className="site-wrap header-inner">
        <Link to="/" className="brand" aria-label="Diary Muslim - Beranda">
          <img src={logo} alt="Diary Muslim" className="brand-logo" />
        </Link>
        <button className="nav-toggle" aria-label="Buka menu" aria-expanded={open} onClick={() => setOpen(!open)}>
          <span /><span /><span />
        </button>
        <nav className={`main-nav${open ? " is-open" : ""}`}>
          <a href="/#fitur">Fitur</a>
          <a href="/#cara-kerja">Cara Kerja</a>
          <a href="/#challenge">Challenge</a>
          <a href="/#majelis">Majelis</a>
          <NavLink to="/about">Tentang</NavLink>
          <a className="nav-cta" href="https://play.google.com/store/apps/details?id=com.diarymuslim" target="_blank" rel="noopener noreferrer">Download App</a>
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-wrap footer-grid">
        <div className="footer-brand">
          <img src={logo} alt="Diary Muslim" className="brand-logo light" />
          <p>Aplikasi Al-Qur&rsquo;an digital berbasis komunitas — baca, dengar, dan bagikan refleksi ayat setiap hari agar tilawah jadi kebiasaan yang istiqomah.</p>
          <p className="footer-verse">&ldquo;Read, listen, and share love everyday.&rdquo;</p>
        </div>
        <nav className="footer-col" aria-label="Jelajahi">
          <h4>Jelajahi</h4>
          <a href="/#fitur">Fitur Utama</a>
          <a href="/#challenge">Challenge Tilawah</a>
          <a href="/#majelis">Majelis &amp; Komunitas</a>
          <Link to="/about">Tentang Kami</Link>
        </nav>
        <nav className="footer-col" aria-label="Bantuan dan legal">
          <h4>Bantuan &amp; Legal</h4>
          <Link to="/term">Syarat &amp; Ketentuan</Link>
          <Link to="/privacy">Kebijakan Privasi</Link>
          <Link to="/termchallenge">Ketentuan Challenge</Link>
          <Link to="/delete-account">Hapus Akun</Link>
        </nav>
        <div className="footer-col">
          <h4>Alamat &amp; Kontak</h4>
          <address className="footer-address">
            <span className="addr-label">Kantor</span>
            <span>PT Diary Muslim Infomedia<br />Patra Jasa Office Tower Lt. 17<br />Jl. Gatot Subroto Kav. 32–34, Kuningan Timur, Setiabudi<br />Jakarta Selatan 12950</span>
          </address>
          <div className="footer-social">
            <a className="icon-btn" href="mailto:admin@diarymuslim.com" aria-label="Kirim email ke admin@diarymuslim.com" title="admin@diarymuslim.com">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>
            </a>
            <a className="icon-btn" href="https://www.instagram.com/diarymuslim.official/" target="_blank" rel="noopener noreferrer" aria-label="Instagram Diary Muslim @diarymuslim.official" title="@diarymuslim.official">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" stroke="none" /></svg>
            </a>
          </div>
        </div>
      </div>
      <div className="site-wrap footer-bottom">
        <span>© 2021–{new Date().getFullYear()} PT Diary Muslim Infomedia. Seluruh hak cipta dilindungi.</span>
        <span>Mushaf Standar Indonesia • Terjemahan Kemenag RI Edisi 2019</span>
        <a
          href="#top"
          className="to-top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          Kembali ke atas ↑
        </a>
      </div>
    </footer>
  );
}
